(ns common.widgets.interop
  (:require [cljs-bean.core :refer [->clj]]
            [uix.core :as uix :refer [$]]))

;; This component is used by `input` Material UI components to fix the
;; "Jumping caret" issue which happens when the component is controlled in re-frame db.
;; Source: https://github.com/reagent-project/reagent/blob/master/examples/material-ui/src/example/core.cljs#L28
(def input-component
  (fn [props] ($ :input (->clj props))))

;; Same as above but for `textarea`
;; Source: https://github.com/reagent-project/reagent/blob/master/examples/material-ui/src/example/core.cljs#L35
(def textarea-component
  (fn [props] ($ :textarea (->clj props))))
